export const ProductUserNeedFieldLabels = {
  title: 'Title',
  risk: 'Risk',
  description: 'Description',
  assignTask: 'Assign Task',
  taskFiles: 'Document References',
  assignDesignInput: 'Assign Design Inputs',
  assignDesignSpec: 'Assign Design Specification',
  assignValidation: 'Assign Validation',
  assignVerification: 'Assign Verifications',
  assignHazard: 'Assign Hazards',
  attachment: 'Attachments',
  components: 'Components',
  release: 'Release'
} as const;

export type ProductUserNeedField = keyof typeof ProductUserNeedFieldLabels;

export const ProductUserNeedFields: ProductUserNeedField[] = Object.keys(
  ProductUserNeedFieldLabels
) as ProductUserNeedField[];
